export default {
  name: 'create',
  path: '/create?isNew',
  decodeParams: ({ isNew }) => ({ isNew: isNew === 'true' }),
  loadComponent: () => import('./index'),
  hasPermissions: (permissions: Array<string>) => permissions.includes('ATD_FLIGHT_CREATE')
};
